import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import Post_content from '../../community/content/Blog_posts.jsx';
import { Cookies } from '../../index.js';
import { useSelector, useDispatch } from 'react-redux';

const data_home = {
    "links": [
        { "to": "/reactapp/visual/category_test/phim-moi-cap-nhat", "text": "Phim mới" },
        { "to": "/reactapp/visual/category_test/viet-nam-clip", "text": "Việt Nam Clip" },
        { "to": "/reactapp/visual/category_test/chau-au", "text": "Mỹ - Châu Âu" },
        { "to": "/reactapp/visual/category_test/trung-quoc", "text": "Trung Quốc" },
        { "to": "/reactapp/visual/category_test/han-quoc-18-", "text": "Hàn Quốc 18+" },
        { "to": "/reactapp/visual/category_test/khong-che", "text": "AV Không che" },
        { "to": "/reactapp/visual/category_test/jav-hd", "text": "Jav HD" },
        { "to": "/reactapp/visual/category_test/hentai", "text": "Hentai" },
        { "to": "/reactapp/visual/category_test/sexhd", "text": "Phim SexHD" },
        { "to": "/reactapp/visual/category_test/vietsub", "text": "Phim sex Vietsub" },
        { "to": "/reactapp/visual/category_test/xvideos", "text": "XVIDEOS" },
        { "to": "/reactapp/visual/category_test/nhat-ban", "text": "Nhật Bản" },
        { "to": "/reactapp/visual/category_test/hoc-sinh", "text": "Học sinh" },
        { "to": "/reactapp/visual/category_test/vung-trom", "text": "Vụng trộm" },
        { "to": "/reactapp/visual/category_test/tap-the", "text": "Tập thể" },
        { "to": "/reactapp/visual/category_test/loan-luan", "text": "Loạn luân" },
        { "to": "/reactapp/visual/category_test/pornhub", "text": "PornHub" },
        { "to": "/reactapp/visual/category_test/hiep-dam", "text": "Hiếp dâm" }
    ]
};

const CategoryLinks = () => {
    const dispatch = useDispatch();
    const myCookieValue = Cookies.get('apikey');
    const stable_coins = useSelector(state => state.stable_coins);

    return (
        <div className="max-w-5xl mx-auto">
            {
                myCookieValue ?
                    (<>    {
                        (stable_coins && stable_coins > 200) ? (
                            <div className="mt-2 mx-2 grid grid-cols-1">
                                <div className="bg-white p-3 rounded-md shadow-md md:col-span-2">
                                    <div className="fixrow row text-center">
                                        {data_home.links.map((link, index) => (
                                            <Link
                                                style={{ textDecoration: "none" }}
                                                to={link.to + '?webappmode=showadview&page=1'}
                                                className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-3 w-auto dark:bg-slate-800 dark:text-white"
                                                key={index}
                                            >
                                                <div className="m-auto">
                                                    <div className="flex items-center justify-start flex-1 space-x-4">
                                                        <span className="font-medium px-2 text-lg">{link.text}</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                    <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'29'} />
                                </div>
                            </div>) : (<>
                                Cần tối thiểu 200 Coins đê dùng tính năng này
                            </>)
                    }
                    </>) :
                    (<>
                        <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'29'} />
                    </>)
            }
        </div>
    );
};



export default CategoryLinks;